// src/utils/results/recordingIdTime.js

/**
 * recordingId format:
 *   2026-02-12T12-58-45.282Z-pzauv
 *
 * We parse the ISO-ish prefix up to the 'Z' and ignore the random suffix.
 */
export function parseTimestampFromRecordingId(recordingId) {
  if (!recordingId || typeof recordingId !== "string") return null;

  // capture: YYYY-MM-DD  HH  MM  SS.mmm  (Z)
  const m = recordingId.match(
    /^(\d{4}-\d{2}-\d{2})T(\d{2})-(\d{2})-(\d{2}\.\d{3})Z/,
  );
  if (!m) return null;

  const [, ymd, hh, mm, ssMs] = m;
  const iso = `${ymd}T${hh}:${mm}:${ssMs}Z`;

  const d = new Date(iso);
  return Number.isFinite(d.getTime()) ? d : null;
}

export function formatDateParts(d, locale = "en-GB") {
  if (!(d instanceof Date) || !Number.isFinite(d.getTime())) {
    return { time: "", date: "" };
  }

  const time = d.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = String(d.getFullYear()).slice(-2);
  const date = `${dd}.${mm}.${yy}`;

  return { time, date };
}
